module.exports = __webpack_public_path__ + "img/img20.fc384ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img20.jpg
// module id = 365
// module chunks = 0